import React from 'react';
import { TimelineMarkers, TodayMarker } from 'react-calendar-timeline';

const oneHour = 60 * 60 * 1000;

interface TimelineMarkersComponentProps {
  divRef: React.RefObject<HTMLDivElement>;
}

const TimelineMarkersComponent: React.FC<TimelineMarkersComponentProps> = ({
  divRef,
}) => {
  return (
    // @ts-ignore - react-calendar-timeline types may not be fully compatible
    <TimelineMarkers>
      {/* @ts-ignore - react-calendar-timeline types may not be fully compatible */}
      <TodayMarker interval={oneHour}>
        {({ styles, date }: any) => {
          const newStyles = {
            ...styles,
            width: '1px',
            backgroundColor: 'transparent',
            borderLeft: '1px dashed #654B78',
            zIndex: '50',
          };

          return (
            <div className="flexVert" style={newStyles} ref={divRef}>
              <div
                className="flexHoriz flexItem"
                style={{ alignItems: 'flex-start' }}
              >
                <div
                  className="dotDayMarker"
                  style={{ marginTop: '0px' }}
                ></div>
              </div>
              <div
                className="flexHoriz flexItem"
                style={{ alignItems: 'flex-end' }}
              >
                <div
                  className="dotDayMarker"
                  style={{ marginBottom: '0px' }}
                ></div>
              </div>
            </div>
          );
        }}
      </TodayMarker>
    </TimelineMarkers>
  );
};

export default TimelineMarkersComponent;
